// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"3a1976cc","25":"39ec13ba","176":"734b4044"}[chunkId] + ".chunk.js";
};